import { attendanceFlagsService } from "@data/services/attendanceFlagsService"
import { brevetFunnelService } from "../../brevet/services/brevetFunnelService"
import { summerFunnelService } from "../../summer/services/summerFunnelService"
import { stageFunnelService } from "../../stage/services/stageFunnelService"
import { inscriptionFunnelService } from "../../inscription/services/inscriptionFunnelService"
import { chaptersService } from "@data/services/chaptersService"
import { interviewReportService } from "@data/services/interviewReportService"
import { liveReportService } from "@data/services/liveReportService"
import { liveServiceV2 } from "@data/services/liveServiceV2"
import { quizzService } from "@data/services/quizzservice"
import { referralService } from "@data/services/referralService"
import { studyProgramsService } from "@data/services/studyProgramsService"
import { stageProgramService } from "@data/services/stageProgramService"
import { achievementsService } from "./achievementsService"
import { activitiesService } from "./activitiesService"
import { authService } from "./authService"
import { backOfficeService } from "./backOfficeService"
import { challengesService } from "./challengesService"
import { familyService } from "./familyService"
import { fastTrackService } from "./fastTrackService"
import { groupAttributionProposalsService } from "./groupAttributionProposalsService"
import { groupAttributionService } from "./groupAttributionService"
import { interviewsService } from "./interviewsService"
import { liveService } from "./liveService"
import { messengerService } from "./messengerService"
import { paymentService } from "./paymentService"
import { pedagogicalObjectivesService } from "./pedagogicalObjectivesService"
import { schoolCardReportService } from "./schoolCardReportService"
import { schoolsService } from "./schoolsService"
import { scoringService } from "./scoringService"
import { shopService } from "./shopService"
import { skillSetsService } from "./skillSetsService"
import { staticDataService } from "./staticDataService"
import { studentsService } from "./studentsService"
import { subscriptionService } from "./subscriptionService"
import { substitutionProposalsService } from "./substitutionProposalsService"
import { tutorMonthlyScoreService } from "./tutorMonthlyScoreService"
import { tutorsService } from "./tutorsService"
import { materialsService } from "./materialsService"
import { npsService } from "./npsService"
import { schoolAssessmentsService } from "./schoolAssessmentsService"
import { studentBriefService } from "./studentBriefService"
import { studyMissionsService } from "./studyMissionsService"
import { samService } from "./samService"
import { tutorAvailabilityService } from "./tutorAvailabilityService"
import { tutorTrainingService } from "./tutorTrainingService"
import { tutorSlotMovesService } from "./tutorSlotMovesService"
import { studentSlotChangeService } from "./studentSlotChangeService"

export const apiService = {
    auth: authService,
    activities: activitiesService,
    schools: schoolsService,
    subscriptionService: subscriptionService,
    scoringService: scoringService,
    achievements: achievementsService,
    challenges: challengesService,
    staticData: staticDataService,
    shop: shopService,
    interviews: interviewsService,
    students: studentsService,
    tutors: tutorsService,
    backOffice: backOfficeService,
    messenger: messengerService,
    skill_sets: skillSetsService,
    live: liveService,
    liveV2: liveServiceV2,
    liveReport: liveReportService,
    quizz: quizzService,
    referral: referralService,
    chapters: chaptersService,
    interviewReport: interviewReportService,
    studyPrograms: studyProgramsService,
    stageProgram: stageProgramService,
    substitutionProposals: substitutionProposalsService,
    groupAttribution: groupAttributionService,
    groupAttributionProposals: groupAttributionProposalsService,
    attendanceFlags: attendanceFlagsService,
    schoolCardReportService: schoolCardReportService,
    fastTrackService: fastTrackService,
    paymentService: paymentService,
    pedagogicalObjectives: pedagogicalObjectivesService,
    familyService: familyService,
    materials: materialsService,
    tutorMonthlyScore: tutorMonthlyScoreService,
    tutorAvailability: tutorAvailabilityService,
    tutorTraining: tutorTrainingService,
    tutorSlotMoves: tutorSlotMovesService,
    studentSlotChange: studentSlotChangeService,
    npsService: npsService,
    schoolAssessments: schoolAssessmentsService,
    studentBrief: studentBriefService,
    studyMissions: studyMissionsService,
    sam: samService,
    brevetFunnel: brevetFunnelService,
    summerFunnel: summerFunnelService,
    stageFunnel: stageFunnelService,
    inscriptionFunnel: inscriptionFunnelService,
}
export { vaporStore } from "./vaporService"
